import React from 'react';
import ReactDom from 'react-dom';
import PropTypes from 'prop-types';
import util from 'Utils/commonUtil';

class Select extends React.Component {
    animationTime = 300;
    handleOpenTimer = null;
    state = {
        opened: false,
        value: '',
    };

    componentWillMount() {
        const {data, valueKey, displayKey, value} = this.props;

        if (value && value === 1) {
            data &&
                data.length > 0 &&
                data.forEach((dataItem, dataIndex) => {
                    if (dataItem.id === value) {
                        this.setState({
                            value: dataItem.name,
                        });
                    }
                });
        }
        this.optionGroup = React.createRef();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.opened !== this.state.opened) {
            if (this.state.opened) {
                this.showOptionGroup();
            } else {
                this.hideOptionGroup();
            }
        }
        if (this.props.value !== prevProps.value) {
            const {data, valueKey, displayKey, value} = this.props;

            data.forEach((item) => {
                const itemValue = valueKey ? item[valueKey] : item;

                if (itemValue === value) {
                    this.setState({
                        value: displayKey ? item[displayKey] : item,
                    });
                }
            });
        }
    }

    handleOpenSelect = () => {
        const select = ReactDom.findDOMNode(this);
        const input = select.getElementsByTagName('input')[0];
        const i = select.getElementsByTagName('i')[0];

        if (this.state.opened || i) {
            input.focus();
        } else {
            input.blur();
        }
    };

    chooseOption = (item) => {
        const {valueKey, displayKey} = this.props;
        this.setState({value: displayKey ? item[displayKey] : item});

        util.isFunction(this.props.onChange) &&
            this.props.onChange(item, valueKey, displayKey);
    };

    inputFocus = () => {
        this.setState({opened: true});

        window.clearTimeout(this.handleOpenTimer);
    };

    inputBlur = () => {
        window.clearTimeout(this.handleOpenTimer);
        this.handleOpenTimer = window.setTimeout(() => {
            this.setState({opened: false});
        }, 300);
    };

    hideOptionGroup() {
        const optionGroup = this.optionGroup.current;

        optionGroup.style.display = 'none';
    }

    showOptionGroup() {
        const optionGroup = this.optionGroup.current;
        const select = ReactDom.findDOMNode(this);
        const selectPosition = this.getPosition(select);

        optionGroup.style.minWidth = `${select.offsetWidth}px`;
        optionGroup.style.position = 'absolute';
        optionGroup.style.left = `${selectPosition.left}px`;
        optionGroup.style.top = `${
            selectPosition.top + select.offsetHeight + 6
        }px`;
        optionGroup.style.transform = 'translateY(-30%)';
        optionGroup.style.opacity = 0;
        optionGroup.style.transition = `${this.animationTime}ms`;
        optionGroup.style.display = 'block';
        optionGroup.style.zIndex = 99999;

        window.setTimeout(() => {
            optionGroup.style.opacity = 1;
            optionGroup.style.transform = '';
        });
    }

    getPosition(element) {
        const position = {
            left: 0,
            top: 0,
        };

        while (element) {
            position.left += element.offsetLeft;
            position.top += element.offsetTop;

            element = element.offsetParent;
        }

        return position;
    }

    getClassName() {
        const {mode, className} = this.props;
        const propsClassName = className.split(' ');
        const defaultClassName = [
            'common-select',
            `common-select-mode-${mode}`,
        ];

        return [...defaultClassName, ...propsClassName].join(' ');
    }

    render() {
        const {value} = this.state;
        const {mode, displayKey, placeholder, options} = this.props;
        const {icon} = options;

        return (
            <div
                className={this.getClassName()}
                {...util.clickOfSingleTap(this.handleOpenSelect)}>
                <input
                    className="common-select-input"
                    type="text"
                    value={value}
                    placeholder={placeholder}
                    readOnly={mode !== 'search'}
                    onFocus={this.inputFocus}
                    onBlur={this.inputBlur}
                />
                {icon.show ? (
                    icon.custom ? (
                        icon.custom
                    ) : (
                        <i
                            className="common-select-icon"
                            style={{borderTopColor: icon.color}}></i>
                    )
                ) : null}
                {ReactDom.createPortal(
                    <div
                        ref={this.optionGroup}
                        className={
                            typeof this.props.isDialog !== 'undefined' &&
                            this.props.isDialog
                                ? 'common-select-option-group-box dialog-common-select-option-group-box'
                                : 'common-select-option-group-box'
                        }>
                        <ul className="common-select-option-group">
                            {this.props.data.map((item, index) => (
                                <li
                                    className="common-select-option"
                                    key={index}
                                    {...util.clickOfSingleTap(
                                        this.chooseOption.bind(this, item),
                                        {isStopPropagation: true},
                                    )}>
                                    {displayKey ? item[displayKey] : item}
                                </li>
                            ))}
                        </ul>
                    </div>,
                    document.getElementsByTagName('body')[0],
                )}
            </div>
        );
    }
}

Select.propTypes = {
    mode: PropTypes.string,
    data: PropTypes.array,
    className: PropTypes.string,
    placeholder: PropTypes.string,
    displayKey: PropTypes.string,
    valueKey: PropTypes.string,
    options: PropTypes.shape({
        icon: PropTypes.shape({
            show: PropTypes.bool,
            custom: PropTypes.element,
            color: PropTypes.string,
        }),
    }),
};

Select.defaultProps = {
    mode: 'select',
    data: [],
    className: '',
    options: {
        icon: {
            show: true,
        },
    },
};

export default Select;
